import {combineReducers} from 'redux';
import DataReducer from './data.reducer';
import FirebaseReducer from './firebase.reducer';
export default combineReducers({
	data: DataReducer,
	firebase: FirebaseReducer
});